module.exports = __webpack_public_path__ + "post-listing-block-5-image@2x-Dmk5rE7.jpg";